<template>
  <div class="task-item">
    <div class="d-flex">
      <b-button
        :class="['check-btn mr-3', { checked: value.done }]"
        @click="value.done = !value.done"
        variant="white"
      >
        <i class="material-icons">
          check
        </i>
      </b-button>
      <div class="input-group">
        <b-form-input
          required
          :class="['task-input', { 'show-delete': showDelete }]"
          type="text"
          v-model="value.text"
          :ref="`taskInput${index}`"
          :placeholder="resources.typeTask"
          @keyup.enter.exact="preventAddTask()"
          @keyup.alt.enter="value.done = !value.done"
          @keyup.shift.enter="value.done = !value.done"
          @keyup.alt.46="$emit('removeTask')"
          @keyup.shift.46="$emit('removeTask')"
          @keyup.shift.up="$emit('moveTask', index - 1)"
          @keyup.shift.down="$emit('moveTask', index + 1)"
          @keyup.alt.up.exact="$emit('changeFocus', index - 1)"
          @keyup.alt.down.exact="$emit('changeFocus', index + 1)"
          @keyup.esc="$emit('blurTask')"
        />
        <b-button
          v-if="showDelete"
          class="remove-btn"
          variant="white"
          @click="$emit('clickRemoveTask', index)"
          @keyup.enter="$emit('removeTask', index)"
        >
          <i class="material-icons">
            delete_forever
          </i>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    index: {
      type: Number,
      default: undefined,
    },
    value: {
      type: Object,
      default: () => ({
        text: {
          type: String,
          default: undefined,
        },
        done: {
          type: Boolean,
          default: undefined,
        },
      }),
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    preventAddTask() {
      if (!this.value.text) return false

      this.$emit('addTask')
    },
  },
  computed: {
    ...mapGetters({
      resources: 'taskInput',
    }),
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.task-item {
  width: 700px;

  .material-icons {
    cursor: pointer;
  }

  .check-btn {
    width: 40px;
    height: 40px !important;
    padding: 6px;
    color: map-get($theme-colors, 'gray02');
    border: 1px solid map-get($theme-colors, 'gray01');

    &.checked,
    &.checked:hover {
      background-color: map-get($theme-colors, 'lima') !important;
      color: white;
    }

    .material-icons {
      line-height: 26px;
      font-size: 26px;
    }
  }

  .input-group {
    display: flex;

    .task-input {
      height: 40px !important;
      border: 1px solid map-get($theme-colors, 'gray01') !important;
      transition: border 0s;

      &.show-delete {
        border-radius: 25px 0px 0px 25px !important;
        border-right: 0px !important;
      }
    }

    .remove-btn {
      border-radius: 0px 25px 25px 0px !important;
      padding-left: 10px;
      z-index: 0;
      height: 40px !important;
      border: 1px solid map-get($theme-colors, 'gray01');

      .material-icons {
        line-height: 20px;
        font-size: 20px;
        padding: 3px 0px;
      }
    }
  }
}
</style>
